import { Type } from '@sinclair/typebox';
import { createOperation, createOperationWithBody } from '../../../routes/createOperation';

export const surveyManageLabelsPaths = {
    '/api/surveys/labels/editable': {
        get: createOperation(
            'surveyManageLabelsControllers.getAll',
            [
                { name: 'searchText', in: 'query', schema: Type.String() },
                { name: 'clientCompanyId', in: 'query', schema: Type.String() },
            ],
            Type.Object({
                items: Type.Array(Type.String()),
            }),
        ),
        post: createOperationWithBody(
            'surveyManageLabelsControllers.updateLabels',
            [{ name: 'clientCompanyId', in: 'query', schema: Type.String() }],
            Type.Object({
                ok: Type.Boolean(),
            }),
            Type.Object({
                oldLabel: Type.String(),
                newLabel: Type.String(),
            }),
        ),
        delete: createOperation(
            'surveyManageLabelsControllers.removeLabels',
            [
                { name: 'clientCompanyId', in: 'query', schema: Type.String() },
                { name: 'label', in: 'query', required: true, schema: Type.String() },
            ],
            Type.Object({
                ok: Type.Boolean(),
            }),
        ),
    },
} as const;
